import { z } from 'zod';

export const nationalityPersonSchema = z.enum([
  'saudi_arabia',
  'egypt',
  'syria',
  'sudan',
  'pakistan',
  'yemen',
  'nepal',
  'india',
  'ghana',
  'bangladesh',
  'sri_lanka',
]);
export type NationalityPerson = z.infer<typeof nationalityPersonSchema>;
